import { createRouter, createWebHistory } from "vue-router";
import store from "../store";
import MainView from "../views/MainView.vue";
import AuthView from "../views/AuthView.vue";
import LoginPage from "../components/LoginPage.vue";
import Dashboard from "../components/Parents/Dashboard.vue";
import ErrorNotFound from "../components/Utils/ErrorNotFound.vue";
import Products from "../components/Parents/Products.vue";
import PointsChecker from "../components/Parents/PointsChecker.vue";
import Purchases from "../components/Parents/Purchases.vue";
import AccountVerification from "../components/Parents/AccountVerification.vue";
import WagerRewards from "../components/Parents/WagerRewards.vue";
import SocialsConfig from "../components/Parents/SocialsConfig.vue";
import GuessTheBalance from "@/components/Parents/GuessTheBalance.vue";

import { useI18n } from "vue-i18n";

const routes = [
  {
    path: "/",
    component: AuthView,
    meta: { alreadyAuth: true },
    children: [
      {
        path: "/",
        name: "login",
        component: LoginPage,
      },
      // {
      //   path: '/register',
      //   name: 'register',
      //   component: RegisterPage,
      // },
    ],
  },

  {
    path: "/admin",
    name: "admin",
    meta: { routeForAdmin: true },
    component: MainView,
    children: [
      {
        path: "/admin/dashboard",
        component: Dashboard,
        meta: {
          title: "Sidebar.Dashboard",
        },
      },
      {
        path: "/admin/account-verification",
        component: AccountVerification,
        meta: {
          title: "Sidebar.Account_Verification",
        },
      },
      {
        path: "/admin/points-checker",
        component: PointsChecker,
        meta: {
          title: "Sidebar.Points_Checker",
        },
      },
      {
        path: "/admin/rewards",
        component: WagerRewards,
        meta: {
          title: "Sidebar.Wager_Rewards",
        },
      },
      {
        path: "/admin/guess-the-balance",
        component: GuessTheBalance,
        meta: {
          title: "Sidebar.Guess_the_Balance",
        },
      },
      {
        path: "/admin/products",
        component: Products,
        meta: {
          title: "Sidebar.Products",
        },
      },
      {
        path: "/admin/purchases",
        component: Purchases,
        meta: {
          title: "Sidebar.Purchases",
        },
      },
      {
        path: "/admin/socials-config",
        component: SocialsConfig,
        meta: {
          title: "Sidebar.Socials_Config",
        },
      },
    ],
  },

  {
    path: "/:pathMatch(.*)*",
    name: "ErrorView",
    component: ErrorNotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  let user = store.state.user;

  if (to.matched.some((rec) => rec.meta.alreadyAuth)) {
    if (user) {
      next("/admin/dashboard");
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.routeForAdmin)) {
    if (!user) {
      next("/");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
